var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "impressum"
  }, [_c('div', {
    staticClass: "heading-3-bold popup-title"
  }, [_vm._v("Impressum")]), _c('div', {
    staticClass: "paragraph-1"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Verantwortlich für den Inhalt")]), _vm._v(" Marco Quinter"), _c('br'), _vm._v(" SWISS ENGINEERS UNITED AG"), _c('br'), _vm._v(" Churerstrasse 54"), _c('br'), _vm._v(" CH-8808 Pfäffikon SZ"), _c('br'), _vm._v(" +41 58 521 19 00"), _c('br'), _c('a', {
    staticClass: "text-highlight"
  }, [_vm._v(" info@seu.ch")])]), _c('div', {
    staticClass: "paragraph-1"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Konzeption und Text")]), _vm._v(" Uta De Monte"), _c('br'), _c('a', {
    staticClass: "text-highlight",
    attrs: {
      "href": " www.kommunikation-demonte.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.kommunikation-demonte.ch")])]), _c('div', {
    staticClass: "paragraph-1"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Design")]), _vm._v(" Tale Mitreski ")]), _c('div', {
    staticClass: "paragraph-1"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Fotos")]), _vm._v(" Tale Mitreski & René Da Rold Pictures ")]), _c('div', {
    staticClass: "paragraph-1"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Webdesign, Programmierung")]), _vm._v(" Tale Mitreski & Kliment Lambevski ")])]);

}]

export { render, staticRenderFns }